import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as Notification } from "../assets/notif.svg";
import NotificationsModal from './NotificationsModal';
import axios from 'axios';
import config from "../config";
import io from 'socket.io-client';

const Header = () => {
    const userData = useSelector((state) => state.user);
    const [showNotifications, setShowNotifications] = useState(false);
    const [notifications, setNotifications] = useState([]);
    const [unreadCount, setUnreadCount] = useState(0);
    const [, setSocket] = useState(null);
    const initData = window.Telegram.WebApp.initData;
    const navigate = useNavigate();

    // Загрузка уведомлений при монтировании компонента
    useEffect(() => {
        fetchNotifications();
    }, []);

    // Инициализация сокета
    useEffect(() => {
        const newSocket = io(config.SOCKET_URL, {
            query: { initData }
        });

        newSocket.on('connect', () => {
            console.log('Соединение с сокетом установлено');
        });

        newSocket.on('connect_error', (error) => {
            console.error('Ошибка подключения к сокету:', error.message);
            // Пробуем загрузить уведомления даже при ошибке сокета
            fetchNotifications();
        });

        // Подписка на получение уведомлений
        newSocket.on('newNotification', (notification) => {
            console.log('Получено новое уведомление:', notification);
            setNotifications(prev => [notification, ...prev]);
            setUnreadCount(prev => prev + 1);
        });

        setSocket(newSocket);

        return () => {
            if (newSocket) {
                console.log('Отключение сокета');
                newSocket.disconnect();
            }
        };
    }, [initData]);

    const fetchNotifications = async () => {
        try {
            const initData = window.Telegram.WebApp.initData;
            const { data } = await axios.post(`${config.API_BASE_URL}/notifications/get`, {
                initData
            });

            if (data.success) {
                setNotifications(data.notifications);
                setUnreadCount(data.notifications.filter(n => !n.read).length);
            }
        } catch (error) {
            console.error('Ошибка при загрузке уведомлений:', error);
        }
    };

    const handleMarkAsRead = async (notificationId) => {
        try {
            const initData = window.Telegram.WebApp.initData;
            const { data } = await axios.post(`${config.API_BASE_URL}/notifications/markAsRead`, {
                notificationId,
                initData
            });

            if (data.success) {
                setNotifications(prev =>
                    prev.map(n => n._id === notificationId ? { ...n, read: true } : n)
                );
                setUnreadCount(prev => prev - 1);
            }
        } catch (error) {
            console.error('Ошибка при отметке уведомления:', error);
        }
    };

    const handleDeleteNotification = async (notificationId) => {
        try {
            const initData = window.Telegram.WebApp.initData;
            const { data } = await axios.post(`${config.API_BASE_URL}/notifications/delete`, {
                notificationId,
                initData
            });

            if (data.success) {
                setNotifications(prev => prev.filter(n => n._id !== notificationId));
                // Обновляем счетчик непрочитанных, если удаляем непрочитанное уведомление
                const deletedNotification = notifications.find(n => n._id === notificationId);
                if (deletedNotification && !deletedNotification.read) {
                    setUnreadCount(prev => prev - 1);
                }
            }
        } catch (error) {
            console.error('Ошибка при удалении уведомления:', error);
        }
    };

    const handleMarkAllAsRead = async () => {
        try {
            const initData = window.Telegram.WebApp.initData;
            const { data } = await axios.post(`${config.API_BASE_URL}/notifications/markAllAsRead`, {
                initData
            });

            if (data.success) {
                setNotifications(prev => prev.map(n => ({ ...n, read: true })));
                setUnreadCount(0);
            }
        } catch (error) {
            console.error('Ошибка при отметке всех уведомлений:', error);
        }
    };

    // Функция для навигации по уведомлению
    const handleNotificationNavigation = (metadata) => {
        console.log('Вызвана функция навигации с метаданными:', metadata);

        if (!metadata) {
            console.log('Метаданные отсутствуют, навигация невозможна');
            return;
        }

        // Закрываем модальное окно уведомлений
        setShowNotifications(false);

        // Навигация в зависимости от типа метаданных
        if (metadata.section) {
            if (metadata.button) {
                // Если есть кнопка, перенаправляем на детальную страницу
                const pageType = metadata.buttonType === 'Гайды' ? 'guide' : 'detail';
                navigate(`/upgrade/${encodeURIComponent(metadata.section)}/${pageType}/${encodeURIComponent(metadata.button)}`);
            } else {
                // Иначе перенаправляем на страницу раздела
                navigate(`/upgrade/${encodeURIComponent(metadata.section)}`);
            }
        }
    };

    return (
        <div className="app-header">
            <div className="app-greeting">
                Приветствую, {userData.username || 'Пользователь'}!
            </div>
            <div className="app-header-icons">
                <div className="app-notification-icon" onClick={() => setShowNotifications(true)}>
                    <Notification />
                    {unreadCount > 0 && <span className="notification-badge">{unreadCount}</span>}
                </div>
                <div className="app-avatar">
                    <img src={window.Telegram.WebApp.initDataUnsafe.user.photo_url} alt="Avatar" />
                </div>
            </div>

            {showNotifications && (
                <NotificationsModal
                    notifications={notifications}
                    onClose={() => setShowNotifications(false)}
                    onMarkAsRead={handleMarkAsRead}
                    onDelete={handleDeleteNotification}
                    onMarkAllAsRead={handleMarkAllAsRead}
                    onNavigate={handleNotificationNavigation}
                />
            )}
        </div>
    );
};

export default Header; 